import { template as template_fabdb87232364c17a33041d26634826d } from "@ember/template-compiler";
import { extractDigits } from 'ember-simplepractice/helpers/extract-digits';
import { fn } from '@ember/helper';
import { on } from '@ember/modifier';
import Component from '@glimmer/component';
import RequestValidatedInput from 'client-portal/components/request/validated-input';
import SharedMaskedInput from 'ember-simplepractice/components/shared/masked-input';
import pick from 'ember-composable-helpers/helpers/pick';
import t from 'ember-intl/helpers/t';
const stripDigits = extractDigits();
export default class SiteWaitlistIntakeFormPhoneFields extends Component {
    updatePhone = (value)=>{
        this.args.onUpdate?.('phone', stripDigits(value));
    };
    static{
        template_fabdb87232364c17a33041d26634826d(`
    <div class="row">
      <div class="col-12" data-test-phone>
        <label class="required" for="waitlist-phone">
          {{t "site.waitlistIntake.fields.phone"}}
        </label>
        <RequestValidatedInput @model={{@form}} @path="phone" @isDirty={{@form.isDirty}}>
          <SharedMaskedInput
            @type="tel"
            @value={{@form.phone}}
            @onChange={{this.updatePhone}}
            id="waitlist-phone"
            data-test-phone-number
          />
        </RequestValidatedInput>
        <label class="boolean" for="waitlist-phone-consent">
          <input
            type="checkbox"
            id="waitlist-phone-consent"
            name="phoneConsent"
            checked={{@form.phoneConsent}}
            {{on "change" (pick "target.checked" (fn @onUpdate "phoneConsent"))}}
            data-test-phone-consent
          />
          {{t "site.waitlistIntake.fields.phoneConsent"}}
        </label>
      </div>
    </div>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
